import React from 'react';
import { ReactComponent as ChatbotReportsIcon } from "../../../../../assets/ChatbotReportsSvgs/ChatbotReportsIcon.svg";
import './style.scss';

interface InsightsMessageBubbleLoaderProps {
    chatbotName?: string;
    timeLabel?: string;
}

const InsightsMessageBubbleLoader: React.FC<InsightsMessageBubbleLoaderProps> = ({
    chatbotName = 'Maghil Bot',
    timeLabel = ''
}) => (
    <div className="insights-message-row ai-message">
        {/* <div className="insights-ai-avatar">
            <ChatbotReportsIcon />
        </div> */}
        <div className="insights-loading-wrapper">
            <div className="insights-message-bubble insights-loading-bubble">
                <span className="insights-loading-text">Analyzing your data...</span>
                <div className="insights-typing-indicator">
                    <span /><span /><span />
                </div>
            </div>
            <div className="insights-loading-meta">
                <span className="insights-loading-bot">{chatbotName}</span>
                <span className="insights-loading-time">• {timeLabel}</span>
            </div>
        </div>
    </div>
);

export default InsightsMessageBubbleLoader;
